import { IMediaConfig } from '@typings/media';
import dashboardParams from './dashboard';

const dashboardConfig: Record<string, Partial<IMediaConfig>> = {
    dashboard: dashboardParams,
};

export default dashboardConfig;
